export function AppFooter() {
  return (
    <div className="pb-6 pt-10 text-center text-xs text-ink-400 dark:text-night-faint">
      <p>
        Erstellt von{" "}
        <a
          href="https://huebbedigital.com"
          target="_blank"
          rel="noreferrer"
          className="font-medium text-plum-700 underline-offset-2 hover:underline dark:text-night-accent"
        >
          HuebbeDigital
        </a>
      </p>
      <p className="mt-2 flex items-center justify-center gap-3">
        <a href="https://huebbedigital.com/imprint.html" target="_blank" rel="noreferrer" className="underline-offset-2 hover:underline">
          Impressum
        </a>
        <a href="https://huebbedigital.com/privacy.html" target="_blank" rel="noreferrer" className="underline-offset-2 hover:underline">
          Datenschutz
        </a>
      </p>
    </div>
  );
}
